
import styled from 'styled-components';

const ModalBackDropWrapper = styled.div`
  display:  ${props => (props.isOpen) ?  'flex' : 'none' };
  opacity: ${props => (props.isOpen) ? 1 : 0};
  position: fixed;
  z-index: 1; 
  padding-top: 100px; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4); 
  z-index: 9999;
  transform: scale(0);

  &.modal-open{
    opacity: 1;
    transform: scale(1);
  }
  
`;

const ModalWrapper = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.33);
  background-color: #ffffff;
  padding: 67px 78px 70px 77px;
  width: 307px;
  height: 123px;
  transition: all .25s linear;
  margin: auto;
  transform: ${props => (props.isOpen) ?'translateY(0vh)' : 'translateY(-100vh)'};
  top: 150px;
  position: relative;
  vertical-align: middle;
  margin: 0 auto;
  align-items: center;
  transform: translate(0,0);
  letter-spacing: 0.1px;
`;

const Header = styled.div`
  display: flex;
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #416c8c;
`;

const headerIdentityStyle ={
  fontFamily: 'DM sans',
  fontSize: '16px',
  fontWeight: '500',
  fontStyle: 'normal',
  lineHeight: '1.38',
  letterSpacing: '0.15px',
  color: '#2a323e'
}


const Content = styled.div`
  font-family: 'Google Sans';
  font-size: 13px;
  line-height: 21px;
  color: #618093;
  margin-top: 13px;
`;

const Actions = styled.div`
  display: flex;
  margin-top: 18px;
  justify-content: space-around;
`;

const ExitButton = styled.img`
  position: absolute;
  top: 16px;
  right: 16px;
  width:18px;
  height:18px;
  &:hover{
    cursor: pointer;
    background: rgba(83, 102, 121, 0.16);
    border-radius: 50%;
    box-shadow: 0 0 0 8px rgb(83 102 121 / 16%);
  }
`;

const WarningIcon = styled.img`
  width: 20px;
  height:20px;
  margin-right: 10px;
  margin-left: -2px;
`;

export { ModalWrapper,
         Header,
         Content,
         Actions,
         ModalBackDropWrapper,
         ExitButton,
         WarningIcon,
         headerIdentityStyle
       };
